export const ACCOUNT_MODALS = {
	RESET_MODAL: 'ResetModal',
	DELETE_MODAL: 'DeleteModal',
	EDIT_MODAL: 'EditModal',
	ADD_MODAL: 'AddModal',
}

export const USER_ROLES = {
	0: 'Admin',
	1: 'Sales',
}

export const USER_ROLES_ENUMS = {
	ADMIN: 0,
	SALES: 1,
}

export const USER_ROLE_OPTIONS = [
	{ label: 'Select Role', value: '' },
	{ label: 'Admin', value: 0 },
	{ label: 'Sales', value: 1 },
]

export const STATUS = {
	0: 'Active',
	1: 'Inactive',
	2: 'Resend Invite',
}

export const STATUS_ENUMS = {
	ACTIVE: 0,
	INACTIVE: 1,
}

export const STATUS_OPTIONS = [
	{ label: 'Select Status', value: '' },
	{ label: 'Active', value: 0 },
	{ label: 'Inactive', value: 1 },
]
